export default __webpack_public_path__ + "static/media/27-combined.10.26760ccc.png";